module.exports = __webpack_public_path__ + "static/media/man-up.03bac1a5.png";